module.exports = __webpack_public_path__ + "static/media/img-error@2x.67dceaa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-error@2x.png
// module id = 421
// module chunks = 0